import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../store/actions';
import { Footer, Spinner, Page, ItemPage } from '../common';
import { useFetch } from '../common/hooks';
import { Home } from './Step1Home';
import { EnterNumbers } from './Step2EnterNumbers';
import { Prize } from './Step3Prize';
import { RedeemForeignUser } from './PrizeCodeStep1';
import { RedeemLoggedUser } from './PrizeCodeStep2';
import { Redeem } from './Step4Redeem';
import { Balance, Balances } from '../common/Balance';
import config from '../config';
import { getImageValue } from '../common/functions';

const Title = styled(Page.Title)`
    height: 10em;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    @media (max-width: ${(props) => props.theme.mobileLimit}) {
        display: none;
    }
`;

const PageTitleAndBalance = styled.div`
    height: 10em;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: ${(props) => props.theme.primary};

    @media (max-width: ${(props) => (!props.hasBalance && props.theme.mobileLimit)}) {
        display: none;
    }
`;

const AllVisiblePageTitleContainer = styled.div`
    height: 10em;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
`;

const AllVisibleTitle = styled(Title)`
    @media (max-width: ${(props) => props.theme.mobileLimit}) {
        font-size: 26px;
        display: flex;
    }
`;


const Lottery = ({
    history,
    location,
    app: { cms },
    match: { params: { slug } },
    user,
    user: { accounts, authenticated, claimPrize },
    userActions: { login, refreshAccounts, refreshClaimPrize },
    defaultStep,
}) => {
    const [prize, setPrize] = useState(null);
    const [prizeCode, setPrizeCode] = useState(null);
    const [option, setOption] = useState(null);
    const [step, setStep] = useState(0);
    const [totalSaldo, setTotalSaldo] = useState(0);
    const [{ data: lottery, loading }] = useFetch(`${config.backendAddress}/api/v1/lotteries/by-slug/${slug}`);

    const [bottomDesription, setBottomDescription] = useState(null);

    const beacon = document.getElementById('beacon-container');
    if(beacon) {
        beacon.hidden = true;
    }

    useEffect(() => {
        const winsAccountsSaldo = accounts.reduce((acc, cur) => {
            // Include wins, shop currency, extra wins
            if(['wins', 'bonus', 'extra_wins'].indexOf(cur.variety) !== -1) {
                return acc + cur.saldo;
            }
            return acc;
        }, 0);
        const saldo = winsAccountsSaldo;
        setTotalSaldo(saldo);
    }, [accounts]);

    useEffect(() => {
        refreshClaimPrize();

        if(defaultStep !== undefined) {
            setStep(defaultStep);
        }

        return () => {
            const beacon = document.getElementById('beacon-container');
            if(beacon) {
                beacon.hidden = false;
            }
        };
    }, []);

    useEffect(() => {
        if(!slug || !cms) return;
        const index = cms.claimable_lotteries.findIndex((item) => item.slug === slug);
        if(index === -1) return;
        setBottomDescription(cms.claimable_lotteries[index]['bottom_description']);
    }, [slug, cms]);

    return (
        <>
            {step === 2 && (
                <Redeem
                    lottery={lottery}
                    user={user}
                    prize={prize}
                    option={option}
                    onClaim={() => history.push('/success-redeem')}
                    onClaimExtra={() => history.push('/success-extra')}
                />
            )}
            {step !== 2 && (
                <Page>
                    <Switch>
                        <Route path='/lunastettavat/:slug' exact render={() =>
                            <PageTitleAndBalance hasBalance={totalSaldo > 0 || claimPrize > 0}>
                                <Title>{config.nuorelleSiivetOnly ? 'Arpojen rekisteröinti' : 'Lunasta'}</Title>
                                {
                                    (user.authenticated && lottery && lottery.show_balance) ? (
                                        <Balances
                                            history={history}
                                            titleText1='Voittosaldosi'
                                            value1={totalSaldo}
                                            hideAddSaldoButton={true}
                                        />
                                    ) : (
                                        claimPrize && (
                                            <Balance titleText='Lunastamaton voitto' titleWidth={'10em'} value={claimPrize} />
                                        )
                                    )
                                }
                            </PageTitleAndBalance>
                        } />

                        <Route path='/lunastettavat/:slug/pikalunastus' render={(props) =>
                            <AllVisiblePageTitleContainer>
                                <AllVisibleTitle>{
                                    props.location.state.product && props.location.state.product.id ?
                                        'Voiton lunastaminen' :
                                        'Osallistu lisäarvontaan'
                                }
                                </AllVisibleTitle>
                            </AllVisiblePageTitleContainer>
                        } />

                        <Route path='/lunastettavat/:slug/nettilunastus' render={() =>
                            <>
                                <PageTitleAndBalance>
                                    {step === 0 && (
                                        <Page.BackButton
                                            onClick={() => history.push(`/lunastettavat/${slug}`)}
                                            text='Takaisin'
                                        />
                                    )}
                                    <Title>{step === 0 ? 'Tarkistusnumerot' : prize && prize.product_id ? 'Onneksi olkoon!' : 'Ei voittoa'}</Title>
                                    {
                                        (user.authenticated && lottery && lottery.show_balance) ? (
                                            <Balances
                                                history={history}
                                                titleText1='Voittosaldosi'
                                                value1={totalSaldo}
                                                hideAddSaldoButton={true}
                                            />
                                        ) : (
                                            claimPrize && (
                                                <Balance titleText='Lunastamaton voitto' titleWidth={'10em'} value={claimPrize} />
                                            )
                                        )
                                    }
                                </PageTitleAndBalance>

                            </>
                        } />
                    </Switch>
                    <Page.Content flex>
                        {!loading && lottery && (
                            <Switch>
                                <Route path='/lunastettavat/:slug' exact render={() => (
                                    <ItemPage>
                                        <ItemPage.Image src={getImageValue(lottery.images, 'large')} />
                                        <ItemPage.Content>
                                            <Home
                                                lottery={lottery}
                                                authenticated={user.authenticated}
                                                slug={slug}
                                                cms={cms}
                                                onLogin={() => login()}
                                                onRedeem={() => {
                                                    setStep(0);
                                                    history.push(`/lunastettavat/${slug}/nettilunastus`);
                                                }} />
                                        </ItemPage.Content>
                                    </ItemPage>

                                )} />
                                <Route
                                    path='/lunastettavat/:slug/pikalunastus'
                                    render={(props) => {
                                        return (
                                            <ItemPage>
                                                <ItemPage.Content>
                                                    <Redeem
                                                        lottery={lottery}
                                                        user={user}
                                                        shopPrize={props.location.state.product}
                                                        shopPrizeOption={props.location.state.option}
                                                        onClaim={() => history.push('/success-redeem')}
                                                        onClaimExtra={() => history.push('/success-extra')}
                                                    />
                                                </ItemPage.Content>
                                            </ItemPage>
                                        );
                                    }}
                                />
                                <Route path='/lunastettavat/:slug/nettilunastus' render={() => (
                                    <>
                                        <ItemPage>
                                            <ItemPage.Image src={getImageValue(lottery.images, 'large')} />
                                            <ItemPage.Content>
                                                {step === 0 && (
                                                    <EnterNumbers
                                                        lottery={lottery}
                                                        claimPrize={claimPrize}
                                                        onContinue={(newPrize) => {
                                                            if (user.authenticated) {
                                                                refreshAccounts();
                                                            }
                                                            setPrize(newPrize);
                                                            if (newPrize?.prize_code) {
                                                                if (user.authenticated) {
                                                                    setStep(4);
                                                                } else {
                                                                    setStep(3);
                                                                }
                                                            } else {
                                                                refreshClaimPrize();
                                                                setStep(1);
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {step === 1 && (
                                                    <Prize
                                                        lottery={lottery}
                                                        prize={prize}
                                                        option={option}
                                                        authenticated={user.authenticated}
                                                        onChangeOption={(option) => setOption(option)}
                                                        onRedeemPrize={() => setStep(2)}
                                                        onSelectPrize={() => {
                                                            history.push('/voittokauppa');
                                                        }}
                                                        onReturn={() => history.push('/')}
                                                        onEnterNew={() => setStep(0)}
                                                    />
                                                )}
                                                {step === 3 && (
                                                    <RedeemForeignUser
                                                        lottery={lottery}
                                                        onSend={() => setStep(4)}
                                                    />
                                                )}
                                                {step === 4 && (
                                                    <RedeemLoggedUser onEnterNew={() => setStep(0)} />
                                                )}

                                            </ItemPage.Content>
                                        </ItemPage>
                                    </>
                                )} />
                            </Switch>
                        )}
                        {loading && <Spinner />}

                        {location.pathname === `/lunastettavat/${slug}` && bottomDesription &&
                         <div
                             style={{ flex: 1, margin: 0 }}
                             dangerouslySetInnerHTML={{
                                 __html: bottomDesription
                             }}
                         >
                         </div>
                        }

                        <Footer />
                    </Page.Content>
                </Page>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        app: state.app,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators({ ...userActions }, dispatch)
    };
};

const ConnectedLottery = connect(mapStateToProps, mapDispatchToProps)(Lottery);

export { ConnectedLottery as Lottery };
